import { render, staticRenderFns } from "./VCSingleTestDataInfo.vue?vue&type=template&id=212af7a8"
import script from "./VCSingleTestDataInfo.vue?vue&type=script&lang=js"
export * from "./VCSingleTestDataInfo.vue?vue&type=script&lang=js"
import style0 from "./VCSingleTestDataInfo.vue?vue&type=style&index=0&id=212af7a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports